import React from 'react';
import {
  ModalsActionTypes,
  MODAL_ACTIONS_CHANGE_PROPS,
  MODAL_ACTIONS_CLEAR,
  MODAL_ACTIONS_CLOSE,
  MODAL_ACTIONS_OPEN,
} from './ModalsActionTypes';

export interface IModalProps {
  title?: string | React.ElementType;
  content?: any;
  genericProps?: any;
  open?: boolean;
}

export type ModalPropsTypes = IModalProps;

export interface IModalReducer {
  component?: React.ElementType;
  componentProps?: IModalProps;
  key: string;
  opened?: boolean;
}

export interface IModalOpenReducer extends IModalReducer {
  component: React.ElementType;
  key: string;
  opened: boolean;
}

export interface IModalChangePropsReducer extends IModalReducer {
  componentProps: IModalProps;
  key: string;
}

export interface IModalsReducer {
  modals: Map<string, IModalReducer>;
}

const INITIAL_STATE: IModalsReducer = {
  modals: new Map(),
};

const getStateToOpen = (state: IModalsReducer, modal: IModalReducer) => {
  state.modals.set(modal.key, modal);
  return { ...state };
};

const getStateChangeProps = (
  state: IModalsReducer,
  key: string,
  componentProps?: IModalProps
) => {
  const aux = state.modals.get(key);
  if (aux) {
    state.modals.set(key, {
      ...aux,
      componentProps: {
        ...aux.componentProps,
        ...componentProps,
      } as IModalProps,
    });
  }
  return { ...state };
};

const getStateToClose = (state: IModalsReducer, key: string) => {
  const aux = state.modals.get(key);
  if (aux) {
    state.modals.set(key, {
      ...aux,
      opened: false,
      componentProps: { ...aux.componentProps, open: false },
    });
  }
  return { ...state };
};

const getStateToClear = (state: IModalsReducer, key: string) => {
  state.modals.delete(key);
  return { ...state };
};

export default function ModalsReducer(
  state: IModalsReducer = INITIAL_STATE,
  action: ModalsActionTypes
) {
  switch (action.type) {
    case MODAL_ACTIONS_OPEN:
      return getStateToOpen(state, action.payload);
    case MODAL_ACTIONS_CHANGE_PROPS:
      return getStateChangeProps(
        state,
        action.payload.key,
        action.payload.componentProps
      );
    case MODAL_ACTIONS_CLOSE:
      return getStateToClose(state, action.payload);
    case MODAL_ACTIONS_CLEAR:
      return getStateToClear(state, action.payload);
    default:
      return state;
  }
}
